interface DataWithBalance {
  balanceUsd: number
}

type GroupedBalances<T extends DataWithBalance> = Record<string, { balances: T[]; groupTotalBalance: number }>

export function groupBalances<T extends DataWithBalance>(data: readonly T[], getGroupKey: (data: T) => string) {
  const sortedData = [...data].sort((a, b) => b.balanceUsd - a.balanceUsd)

  const groupedBalances = sortedData.reduce(
    (acc, data) => {
      const groupKey = getGroupKey(data)
      if (!acc[groupKey]) {
        acc[groupKey] = {
          balances: [],
          groupTotalBalance: 0,
        }
      }
      acc[groupKey].balances.push(data)
      acc[groupKey].groupTotalBalance += data.balanceUsd
      return acc
    },
    {} as GroupedBalances<T>
  )

  return Object.entries(groupedBalances)
    .map(([groupName, { balances, groupTotalBalance }]) => ({
      groupName,
      balances,
      groupTotalBalance,
    }))
    .sort((a, b) => b.groupTotalBalance - a.groupTotalBalance)
}
